import { useDispatch, useSelector } from 'react-redux';
import { ExportType, Values } from '../interfaces';
import {
  exportRefundDetail,
  exportRefunds,
  getBanks,
  getPaymentMethodsForRefunds,
  getRefundDetail,
  getRefunds,
  sendRequestRefund,
  setRefundDetail,
  showExportRefunds,
} from './actions';
import { RefundsSelectors } from './selectors';
import { Filters, Refund } from './interfaces';

export const useRefunds = () => {
  const dispatch = useDispatch();

  return {
    loading: useSelector(RefundsSelectors.getLoading),
    error: useSelector(RefundsSelectors.getError),
    allRefunds: useSelector(RefundsSelectors.getAllRefunds),
    requestRefund: useSelector(RefundsSelectors.getRequestRefund),
    paymentMethods: useSelector(RefundsSelectors.getPaymentMethods),
    export: useSelector(RefundsSelectors.getExport),
    exportType: useSelector(RefundsSelectors.getExportType),
    getRefunds: (page?: number, filter?: Filters) => dispatch(getRefunds(page, filter)),
    getBanks: (country: string) => dispatch(getBanks(country)),
    sendRequestRefund: (values: Values) => dispatch(sendRequestRefund(values)),
    getPaymentMethodsForRefunds: (country: string) => dispatch(getPaymentMethodsForRefunds(country)),
    setRefundDetail: (data: Refund) => dispatch(setRefundDetail(data)),
    getRefundDetail: (id: number) => dispatch(getRefundDetail(id)),
    exportRefundDetail: (id: number) => dispatch(exportRefundDetail(id)),
    refundDetail: useSelector(RefundsSelectors.getRefundDetail),
    showExportRefunds: (show: boolean) => dispatch(showExportRefunds(show)),
    exportRefunds: (filter: string, type: ExportType) => dispatch(exportRefunds(filter, type)),
  };
};
